var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDestinationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 38,
    viewBox: "0 0 28 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2583 17.5016L14 37.0001L2.7417 17.5016L25.2583 17.5016Z",
    fill: "#FF7200",
    stroke: "#FF7200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12.7938C26 19.2924 20.6425 24.5877 14 24.5877C7.35745 24.5877 2 19.2924 2 12.7938C2 6.2953 7.35745 1 14 1C20.6425 1 26 6.2953 26 12.7938Z",
    fill: "white",
    stroke: "#FF7200",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.794 17C11.56 17 11.378 16.9393 11.248 16.818C11.1267 16.688 11.066 16.506 11.066 16.272V8.563C11.066 8.329 11.1267 8.15133 11.248 8.03C11.378 7.9 11.56 7.835 11.794 7.835H14.303C15.811 7.835 16.9723 8.22933 17.787 9.018C18.6103 9.798 19.022 10.929 19.022 12.411C19.022 13.1477 18.918 13.802 18.71 14.374C18.502 14.946 18.1943 15.427 17.787 15.817C17.3883 16.1983 16.8987 16.493 16.318 16.701C15.7373 16.9003 15.0657 17 14.303 17H11.794ZM12.418 15.869H14.225C14.797 15.869 15.291 15.7997 15.707 15.661C16.1317 15.5137 16.487 15.297 16.773 15.011C17.059 14.725 17.2713 14.3653 17.41 13.932C17.5487 13.4987 17.618 12.9917 17.618 12.411C17.618 11.2583 17.332 10.396 16.76 9.824C16.1967 9.252 15.3517 8.966 14.225 8.966H12.418V15.869Z",
    fill: "#FF7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationIcon);
export default __webpack_public_path__ + "static/media/destination_icon.fbd03ccf0714e1504e26f9f898760159.svg";
export { ForwardRef as ReactComponent };